import { Component, OnInit, ViewChild, Input, EventEmitter, Output, OnChanges, SimpleChanges, HostListener } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';



@Component({
  selector: "table-perfil-acesso",
  templateUrl: "./table-perfil-acesso.component.html",
  styleUrls: ['./table-perfil-acesso.component.scss']

})
export class TablePerfilAcesso implements OnInit {
  permissions: MatTableDataSource<any>;
  selection = new SelectionModel<Element>(true, []);
  allComplete: boolean = false

  @ViewChild('sort', { static: false }) sort: MatSort;
  @Input() dataPermissions: Array<any>
  @Input() filterPermissions: EventEmitter<any>;
  @ViewChild('profilePermissions', { static: false }) profilePermissions: any;

  @Output() filterProfile: EventEmitter<any> = new EventEmitter<any>();
  permissionFilter: any;
  filterAutoComplete: any;


  ngOnInit() {
    this.getPermissions();
    this.permissions.sort = this.sort;
  }

  ngAfterViewInit() {
    this.permissions.sort = this.sort;
  }

  getPermissions() {
    let dataPermission = this.dataPermissions;
    dataPermission.sort((a, b) => {
      if (a.name === null) { a.name = '' };
      if (b.name === null) { b.name = '' };
      return (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
    })
    this.permissions = new MatTableDataSource(dataPermission);

    this.permissions.sort = this.sort;
    this.isAllSelected()
  }

  filterPermissionsInput(event) {
    this.permissionFilter = (event.target as HTMLInputElement).value;
    this.permissions.filter = this.permissionFilter;
    if (this.permissionFilter.length > 0) {
      this.filterAutoComplete = this.permissions.filteredData;
    } else if (this.permissionFilter.length == 0) {
      this.permissionFilter = [];
    }

  }

  toogleAllSelected() {
    this.allComplete = !this.allComplete;
    this.permissions.data.forEach((row) => row.checked = this.allComplete)
  }

  isAllSelected() {
    this.allComplete = this.permissions.data.every((row) => row.checked == true);
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleSelection(row) {
    this.permissions.data.forEach((data) => {
      if (row.id === data.id) {
        row.checked = !row.checked;
      }
    })
    this.isAllSelected()
  }

}
